import {Space} from "antd";
import {SessionSettingsFormFields} from "./settings";
import {SessionOfferingFormProps} from "./types";
import {
  CreateSessionOfferingFormGroups,
  EditSessionOfferingFormGroups,
} from "../../accordion/data";
import {applyOfferingFormFeatureFlags} from "../../accordion/apply-feature-flags-to-form-groups";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {SessionPricingFormFields} from "./pricing";
import {SessionAvailabilityScheduleSummary} from "./availability/schedule-summary";
import {SessionRedirectAfterPurchaseFormFields} from "./redirect-after-purchase";

export function CreateSessionOfferingForm({
  formType,
  isGeneralInformationError,
  isLocationError,
  isPricingError,
  isSettingsError,
  isAvailabilityError,
}: SessionOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(CreateSessionOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              <SessionPricingFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Availability") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isAvailabilityError}
              summary={<SessionAvailabilityScheduleSummary />}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Location") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isLocationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionSettingsFormFields formType={formType} showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionRedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else return null;
      })}
    </Space>
  );
}

export function EditSessionOfferingForm({
  formType,
  isGeneralInformationError,
  isLocationError,
  isPricingError,
  isSettingsError,
  isCoverImagesError,
  isAvailabilityError,
}: SessionOfferingFormProps) {
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      {applyOfferingFormFeatureFlags(EditSessionOfferingFormGroups).map((fg, index) => {
        if (fg.title === "General information") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isGeneralInformationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Cover image") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isCoverImagesError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Pricing") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isPricingError}
            >
              <SessionPricingFormFields />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Availability") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isAvailabilityError}
              summary={<SessionAvailabilityScheduleSummary />}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Location") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isLocationError}
            >
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Email automation") {
          return (
            <OfferingFormAccordionItem key={fg.title} index={index} title={fg.title}>
              {fg.children}
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Settings") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionSettingsFormFields formType={formType} showUrlRedirect={false} />
            </OfferingFormAccordionItem>
          );
        } else if (fg.title === "Redirect after purchase") {
          return (
            <OfferingFormAccordionItem
              key={fg.title}
              index={index}
              title={fg.title}
              isError={isSettingsError}
            >
              <SessionRedirectAfterPurchaseFormFields />
            </OfferingFormAccordionItem>
          );
        } else return null;
      })}
    </Space>
  );
}
